import React, { useEffect } from "react";
import NavbarComp from "../Components/NavbarComp";
import Footer from "./Footer";
const about = require("../img/about.jpeg");

export default function About() {
    useEffect(()=>{
        window.scrollTo(0,0)
    },[])
    return (
        <>
            <NavbarComp />
            <div className="about-container">
                <p className="about-heading">About Dr. Emad</p>
                <hr className="underline"/>
                <div className="about-body">
                    <img src={about} alt="" className="about-me-img" />
                    <p className="about-text">
                        Dr. Emad Mohammed is a passionate physician, learner,
                        and educator. He has 8 years of experience in providing
                        patient care in a variety of settings. He is a strong
                        advocate of ethical and standard healthcare and the
                        appropriate use of healthcare resources.
                    </p>
                    
                    <p className="about-text">
                        He completed his undergraduate training i.e. MBBS at
                        Bhaskar Medical College, Hyderabad in 2015, after which
                        in the same year he joined the post-graduate training in
                        Clinical Pharmacology in the same college.
                    </p>
                    <p className="about-text">
                        During the post-graduate training to pursue his clinical
                        practice, he joined Premier hospital, Hospital as an
                        on-call doctor in 2015. This is where he was exposed to
                        emergency medicine and intensive care medicine. In 2016
                        he enrolled in the 3-year training program in emergency
                        medicine provided by the Society of emergency medicine
                        of India in Premier Hospital.
                    </p>
                    
                    <p className="about-text">
                        In 2018 due to unforeseen circumstances, he dropped out
                        at the end of the final year of the emergency medicine
                        training program. The experiences gained during this
                        period changed the way he saw the world and pushed him
                        to learn deeper, think broader, and made him more
                        empathetic towards his patients.
                    </p>
                    
                    <p className="about-text">
                        During that phase, he grew an interest in lifestyle
                        disorders, disease prevention, and health maintenance
                        and since then he has contributed his time and energy to
                        achieve the same. His consultations involve educating
                        the patient, setting goals, and rational and minimal use
                        of medicines as possible.
                    </p>
                    
                    <p className="about-text">
                        He completed his postgraduate training in Clinical
                        Pharmacology in 2021.
                    </p>
                    
                    <p className="about-text">
                        In 2022 he completed a training program in healthcare
                        management to understand the ecosystem of healthcare in
                        India.
                    </p>
                    
                    <p className="about-text">
                        Presently He works in Dr. Patnam Mahendra reddy
                        institute of medical Sciences, Chevella as a Senior
                        resident, educating and building the future generations
                        of doctors. At other times he provides consultation to
                        the patients online and offline.
                    </p>
                    
                    <p className="about-text">
                        In the coming years, he plans to build a better
                        healthcare system in India and also wishes to try his
                        hand at medical journalism.
                    </p>
                </div>
            </div>
            <Footer />
        </>
    );
}
